import { render } from "./SurveyDiffDialog.vue?vue&type=template&id=1c497572"
import script from "./SurveyDiffDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDiffDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__